import { EFavoritesActionTypes } from '../../actions/favorite';
import { IFavoriteState } from '../../types/favorite';
import { TReduxActions } from '../../types/redux';

export const INITIAL_FAVORITE_STATE: IFavoriteState = {
  isFavorite: false,
  isMotivationPopupVisible: false,
};

export function favoriteReducer(state: IFavoriteState = INITIAL_FAVORITE_STATE, action: TReduxActions) {
  switch (action.type) {
    case EFavoritesActionTypes.ChangeMotivationPopupState: {
      return {
        ...state,
        isMotivationPopupVisible: action.payload,
      };
    }
    case EFavoritesActionTypes.ChangeFavoriteState: {
      return {
        ...state,
        isFavorite: action.payload,
      };
    }
    default:
      return state;
  }
}
